import React, { useRef } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import "./style.css";

const EmbedModal = (props) => {
  const textarea_ref = useRef();

  const copyTextArea = () => {
    textarea_ref.current.select();
  };

  return (
    <div id="Category-Personalize-Modal">
      <div className="embed-modal">
        <React.Fragment>
          <div className="header">
            <h2>{props.modalText}</h2>
            <CopyToClipboard
              text={props.modalHtml}
              onCopy={() => copyTextArea()}
            >
              <button style={{ marginBottom: "5px" }}>Copy</button>
            </CopyToClipboard>
            <textarea
              ref={textarea_ref}
              readOnly
              style={{ width: "100%", height: "80px", fontSize: 12 }}
              defaultValue={props.modalHtml}
            />
            <span style={{ fontSize: "12px" }}>
              <em>
                iframe width and height may be adjusted as desired (minimum
                supported width is 500px, maximum supported width is 720px);
                results may vary
              </em>
            </span>
          </div>
        </React.Fragment>
      </div>
    </div>
  );
};

export default EmbedModal;
